// V1
// import { useSearchParams } from 'react-router-dom';

// const useQueryParams = (keys, value) => {
//     const [searchParams, setSearchParams] = useSearchParams();

//     const getParams = keys?.map(key => searchParams.get(key) ?? value ?? null);

//     const setParams = (params) => {
//         Object.keys(params).forEach(key => {
//             if (params[key] === undefined || params[key] === null) {
//                 searchParams.delete(key);
//             } else {
//                 searchParams.set(key, params[key]);
//             }
//         });
//         setSearchParams(searchParams);
//     };

//     return [...getParams, setParams]
// };

// export default useQueryParams;

// V2 - combined version
import { useSearchParams } from "react-router-dom";

const useQueryParams = (defaults = {}) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const values = Object.keys(defaults).reduce((acc, key) => {
        acc[key] = searchParams.get(key) ?? defaults[key];
        return acc;
    }, {});

    const setParams = (params) => {
        const next = new URLSearchParams(searchParams);

        Object.entries(params).forEach(([key, value]) => {
            if (value === undefined || value === null) {
                next.delete(key);
            } else {
                next.set(key, value);
            }
        });

        setSearchParams(next);
    };

    return [values, setParams];
};

export default useQueryParams;
